/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const validateCardResponseSchema = z
	.object({
		access: z.string(),
		refresh: z.string(),
		phone: z.string(),
	})
	.describe("Сериализатор для успешного ответа валидации карты.");
